import { atom, useAtom, useSetAtom } from 'jotai';

export const reasoningAtom = atom({
  isReasoning: false,
  isGenerating: false,
});

// Read + set (re-renders when atom changes). Use this in the global Reasoning
// panel which actually displays the value.
export const useReasoning = () => useAtom(reasoningAtom);

// Set-only (does NOT subscribe; consumer never re-renders when atom changes).
// Perf (Phase 9.3): TextTransform only writes to this atom, never reads it.
// Using useSetAtom here prevents every TextTransform on the canvas from
// re-rendering whenever any single node toggles reasoning state.
export const useSetReasoning = () => useSetAtom(reasoningAtom);
